import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { env } from '../config/env';
import { ApiService } from '../services/api.service';
import { Campaign } from '../models/types';

@Component({standalone:true,imports:[CommonModule,FormsModule,RouterLink],
  templateUrl:'./leads.page.html',styleUrls:['./leads.page.css']})
export class LeadsPage implements OnInit {
  campaigns=signal<Campaign[]>([]);
  data=signal<any>(null);
  loading=signal(false);
  error=signal('');
  campaign=''; search=''; outcome=''; status=''; offset=0; readonly pageSize=50;
  Math=Math;
  constructor(private http:HttpClient,private api:ApiService) {}
  async ngOnInit() {
    const result=await Promise.allSettled([this.api.listCampaigns(),this.load()]);
    if (result[0].status==='fulfilled') this.campaigns.set(result[0].value);
  }
  label(value:string) {
    return ({unclassified:'Not classified',pending:'Queued',scheduled:'Follow-up scheduled',calling:'Calling now',
      completed:'Concluded',failed:'Review needed',interested:'Interested / demo requested',callback:'Callback requested',
      converted:'Confirmed sale',not_interested:'Not interested',incomplete:'No clear conclusion',
      no_answer:'No answer',do_not_call:'Do not call',audio_problem:'Audio problem',
      connection_failed:'Connection failed',interrupted:'Conversation interrupted'} as Record<string,string>)[value] || value.replaceAll('_',' ');
  }
  counts(key:'outcomes'|'statuses') {
    return Object.entries(this.data()?.[key] || {}).map(([key,count])=>({key,count:count as number})).sort((a,b)=>b.count-a.count || a.key.localeCompare(b.key));
  }
  async choose(key:string,kind:'outcome'|'status') {
    this[kind]=this[kind]===key?'':key; await this.load();
  }
  async load(reset=true) {
    if (this.loading()) return;
    if (reset) this.offset=0;
    this.loading.set(true); this.error.set('');
    try {
      const params:Record<string,string>={offset:String(this.offset),limit:String(this.pageSize)};
      if (this.campaign) params['campaign_id']=this.campaign;
      if (this.search.trim()) params['search']=this.search.trim();
      if (this.outcome) params['outcome']=this.outcome;
      if (this.status) params['status']=this.status;
      this.data.set(await firstValueFrom(this.http.get<any>(`${env.apiUrl}/api/v1/leads/overview`,{params})));
    } catch(error:any) { this.error.set(error?.error?.detail || `Unable to load leads${error?.status?' (API '+error.status+')':''}.`); }
    finally { this.loading.set(false); }
  }
  async page(step:number) { if (!this.loading()) { this.offset=Math.max(0,this.offset+step*this.pageSize); await this.load(false); } }
}
